var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var IpcSmdPadGeneratorInteractionModel = require('../ipcSmdPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var MoldedBodyPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcSmdPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(MoldedBodyPadGeneratorInteractionModel, IpcSmdPadGeneratorInteractionModel);
MoldedBodyPadGeneratorInteractionModel.$class = 'MoldedBodyPadGeneratorInteractionModel';

module.exports = MoldedBodyPadGeneratorInteractionModel;

MoldedBodyPadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    IpcSmdPadGeneratorInteractionModel.prototype.initialize.call(this);

    this.componentFamily = this.shadow("componentFamily",
        function() {
            return self.data.componentFamily();
        },
        function(value) {
            return self.data.componentFamily(value);
        }, [
            self.data.componentFamily
        ]
    );

    this.oddPadWidthMin = this.shadow("oddPadWidthMin",
        function() {
            return self.data.oddPadWidthMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadWidthMin(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.oddPadWidthMin, this.userSettingsModel.distanceUnit
        ]
    );

    this.oddPadWidthMax = this.shadow("oddPadWidthMax",
        function() {
            return self.data.oddPadWidthMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadWidthMax(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.oddPadWidthMax, this.userSettingsModel.distanceUnit
        ]
    );

    this.oddPadHeightMin = this.shadow("oddPadHeightMin",
        function() {
            return self.data.oddPadHeightMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadHeightMin(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.oddPadHeightMin, this.userSettingsModel.distanceUnit
        ]
    );

    this.oddPadHeightMax = this.shadow("oddPadHeightMax",
        function() {
            return self.data.oddPadHeightMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadHeightMax(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.oddPadHeightMax, this.userSettingsModel.distanceUnit
        ]
    );
};

MoldedBodyPadGeneratorInteractionModel.prototype.getInspectorElementForComponentFamily = function() {
    var componentFamilyList = [];

    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.moldedBodyComponentFamily) {
        var c = cio_datamodel.IpcDataModel.ComponentAttribute.moldedBodyComponentFamily[t];
        componentFamilyList.push([this.LCLZ(t, c), c]);
    }

    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('componentFamily', 'Component Family'), this.componentFamily, componentFamilyList)];
};

MoldedBodyPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    var normalTerminalLength = PackageGeneratorInspectorConfig.getMinMaxRow('L', this.LCLZ('terminalLength', 'Terminal Length'), false, this.padWidthMin, false, this.padWidthMax, this.userSettingsModel.distanceUnit);
    var oddTerminalLength = PackageGeneratorInspectorConfig.getMinMaxRow('L1', this.LCLZ('oddTerminalLength', 'Odd Terminal Length'), false, this.oddPadWidthMin, false, this.oddPadWidthMax, this.userSettingsModel.distanceUnit);

    return [normalTerminalLength, oddTerminalLength];
};

MoldedBodyPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    var normalTerminalWidth = PackageGeneratorInspectorConfig.getMinMaxRow('b', this.LCLZ('terminalWidth', 'Terminal Width'), false, this.padHeightMin, false, this.padHeightMax, this.userSettingsModel.distanceUnit);
    var oddTerminalWidth = PackageGeneratorInspectorConfig.getMinMaxRow('b1', this.LCLZ('oddTerminalWidth', 'Odd Terminal Width'), false, this.oddPadHeightMin, false, this.oddPadHeightMax, this.userSettingsModel.distanceUnit);

    return [normalTerminalWidth, oddTerminalWidth];
};

MoldedBodyPadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('bodyLength', 'Body Length'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

MoldedBodyPadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyLengthMin, false, this.bodyLengthMax, this.userSettingsModel.distanceUnit)];
};

MoldedBodyPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintMolded));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForOddPadLengthInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForOddPadWidthInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForPadGapInCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForComponentFamily());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};